module.exports = __webpack_public_path__ + "static/media/measureArea.ea84a990.svg";